import {
  IconFileBend,
  Inspector,
  GreyGrey70
} from '@sequencehq/core-components'
import { FC } from 'react'
import { QuoteAttachments } from './QuoteAttachments'

export const AttachmentsInspectorItem: FC = () => {
  return (
    <Inspector.IconItem
      data-testid="attachments.inspector.item"
      tooltip="Attachments"
      content={<QuoteAttachments />}
      icon={<IconFileBend color={GreyGrey70} />}
    />
  )
}
